module.exports = __webpack_public_path__ + "static/media/logo.3f2ac182.svg";